import lottie from 'lottie-web'

// to load lottie add class js-load-lottie   attributes: data-json, data-loop, data-autoplay, data-play-on-hover
// to play lottie when scrolled in screen add class js-play-lottie-on-scrolled


export function loadElementLottie(elements) {
  elements.each(function () {
    if (! this.classList.contains('loaded')){
      this.classList.add('loaded')
      let json = this.getAttribute('data-json')
      let loop = this.getAttribute('data-loop')
      if (!loop) loop = false
      let autoplay = this.getAttribute('data-autoplay')
      if (!autoplay) autoplay = false
      let playOnHover = this.getAttribute('data-play-on-hover')
      if (!playOnHover) playOnHover = false
      let name = this.getAttribute('data-name')
      let speed = this.getAttribute('data-json-speed')
      if (!speed) speed = 1

      let animation = lottie.loadAnimation({
        container: this,
        animType: 'svg',
        loop: loop,
        autoplay: autoplay,
        path: json,
        name: name,
      });
      if (speed !== 1) animation.setSpeed(speed)

      // go to start, to later can lottie.play
      // if (!playOnHover) {
      //   animation.onComplete = function () {
      //     animation.goToAndStop(0, true)
      //   }
      // }

      // play on hover
      if (playOnHover) {
        this.addEventListener("mouseover", () => {
          animation.setDirection(1);
          animation.play();
        });
        this.addEventListener("mouseleave", () => {
          animation.setDirection(-1);
          animation.play();
        });
      }

    }
  })
}


export function playLottie(el){
  lottie.goToAndStop(0, true, el.data('name'))
  lottie.play(el.data('name'))
}

export function loopPlayLottie(el){
  lottie.goToAndStop(0, true, el.data('name'))
  lottie.play(el.data('name'))
  let interval = el.data('lottie-interval') ? el.data('lottie-interval') : 4000
  setInterval(()=> loopPlayLottie(el), interval)
}



window.addEventListener('load', (event) => {
  loadElementLottie($('.js-load-lottie'))
})


